import ModalUpdateProfile from 'newComponents/ModalUpdateProfile';
import BannerReclame from 'assets/images/banner-reclame-aqui.jpg';
import BannerBloqueio from 'assets/images/banner-bloqueio.png';
import BannerAbastecimento from 'assets/images/banner-solicitacao-abastecimento.png';
import BannerNovoAbastecimento from 'assets/images/banner-nova-solicitacao-abastecimento.jpg';
import BannerAvisoMFA from 'assets/images/banner-aviso-mfa.png';
import BannerAvisoPIX from 'assets/images/banner-aviso-pix.png';
import BannerIncidenteRs from 'assets/images/banner-comunicado-rs.png';
import { TYPE_PROMOTION } from './enums';
import { ConfigPromotionsModel } from './types';

export const config: ConfigPromotionsModel[] = [
  {
    type: TYPE_PROMOTION.RECLAMEAQUI,
    start: new Date(2022, 8, 1, 0, 0, 0),
    end: new Date(2022, 10, 18, 23, 59, 59),
    img: BannerReclame,
    linkPromotion:
      'https://www.reclameaqui.com.br/premio/votacao/empresa/ultragaz/',
    buttonLink: true,
    showPath: '/portal',
  },
  {
    type: TYPE_PROMOTION.BLOQUEIOS,
    start: new Date(2022, 8, 1, 0, 0, 0),
    end: new Date(2022, 11, 31, 23, 59, 59),
    img: BannerBloqueio,
    linkPromotion: '',
    buttonLink: false,
    showPath: '/portal',
  },
  {
    type: TYPE_PROMOTION.ABASTECIMENTO,
    start: new Date(2023, 3, 3, 0, 0, 0),
    end: new Date(2023, 3, 19, 23, 59, 59),
    img: BannerAbastecimento,
    linkPromotion: '',
    localStorageKey: 'closeBannerPromotion',
    buttonLink: false,
    showPath: '/portal',
  },
  {
    type: TYPE_PROMOTION.NPS,
    title: 'Gostaríamos de entender sua experiência como cliente Ultragaz.',
    subTitle: 'É simples, apenas 1 pergunta!',
    linkPromotion: '',
    dinamicLinkPromotion: true,
    localStorageKey: 'closeBannerNPS',
    start: new Date(2023, 11, 1, 0, 0, 0),
    end: new Date(2023, 11, 22, 23, 59, 59),
    buttonLink: false,
    showPath: '/portal',
  },
  {
    type: TYPE_PROMOTION.UPDATEPROFILE,
    CustomModalComponent: ModalUpdateProfile,
    buttonLink: false,
    showPath: '/portal',
  },
  {
    type: TYPE_PROMOTION.REFUEL,
    start: new Date(2023, 0, 1, 0, 0, 0),
    end: new Date(2023, 6, 14, 23, 59, 59),
    img: BannerNovoAbastecimento,
    linkPromotion: '',
    localStorageKey: 'closeBannerNewRefuel',
    buttonLink: false,
    showPath: '/portal',
  },
  {
    type: TYPE_PROMOTION.AVISO_MFA,
    img: BannerAvisoMFA,
    localStorageKey: 'closeBannerAvisoMFA',
    buttonLink: false,
    customWidth: '600px',
    customHeight: '600px',
    showPath: '/portal',
  },
  {
    type: TYPE_PROMOTION.AVISO_PIX,
    img: BannerAvisoPIX,
    localStorageKey: 'closeBannerAvisoPIX',
    buttonLink: false,
    start: new Date(2024, 1, 21, 0, 0, 0),
    end: new Date(2024, 3, 28, 23, 59, 59),
    linkPromotion:
      'https://www.ultragaz.com.br/clientes-ultragaz-empresarial-agora-podem-pagar-com-pix/',
    customWidth: '550px',
    customHeight: '750px',
    customMobileWidth: '400px',
    customMobileHeight: '600px',
    showPath: '/boletos',
  },
  {
    type: TYPE_PROMOTION.INCIDENTES_RS,
    img: BannerIncidenteRs,
    localStorageKey: 'closeBannerIncidenteRs',
    buttonLink: false,
    start: new Date(2024, 4, 22, 0, 0, 0),
    end: new Date(2024, 4, 30, 0, 0, 0),
    customWidth: '400px',
    customHeight: '600px',
    customMobileWidth: '350px',
    customMobileHeight: '550px',
    showPath: '/portal',
  },
];
